// eslint-disable @typescript-eslint/no-explicit-any
import { Action } from 'redux'
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeLatest,
} from 'redux-saga/effects'
import { testFeature } from '@opallabs/principles'
import { fetchMoments } from '../../actions/getMoments/fetchMoments'
import dispatchedMomentActions, {
  MomentActions,
} from '../../actions/getMoments/MomentActions'
import { fetchWorkflowsByMoments } from '../../actions/getWorkflowsByMoments/fetchWorkflowsByMoments'
import { loadJsonApiEntities } from '../../actions/loadJsonApiEntities'

type Payload = {
  params: { [key: string]: string | number | undefined }
  currentBrandId: string | undefined
  scopeToCurrentBrand: boolean
  component: string
  startMomentFetch: () => undefined
  endMomentFetch: () => undefined
}

type Yield =
  | boolean
  | PutEffect
  | undefined
  | CallEffect
  | null
  | Promise<boolean>
type Return = void
export interface ActionWithPayload extends Action {
  payload: Payload
}

export function* fetchMomentsWithWorkflowStatus(
  action: ActionWithPayload
): Generator<Yield, Return, any> {
  try {
    const {
      startMomentFetch,
      endMomentFetch,
      params,
      scopeToCurrentBrand,
      currentBrandId,
      component,
    } = action.payload

    if (scopeToCurrentBrand) {
      params['filter[brand_id]'] = currentBrandId
    }
    yield startMomentFetch()
    const momentsResponse = yield call(fetchMoments, params)
    // Tagged so the week view can tell its own search results from moments
    // that arrive over the websocket.
    const putResponse = yield put(
      loadJsonApiEntities({ ...momentsResponse.data, view: component })
    )
    if (testFeature('workflow_on_moments')) {
      const moments = putResponse.payload.data
      if (moments.length) {
        const workflowResponse = yield call(fetchWorkflowsByMoments, moments)
        yield put(loadJsonApiEntities(workflowResponse.data))
      }
    }
    yield endMomentFetch()
  } catch (err) {
    yield action.payload.endMomentFetch()
    put(dispatchedMomentActions.getMomentsError(err))
  }
}

export function* fetchMomentsSaga(): Generator<ForkEffect, void, void> {
  yield takeLatest(
    MomentActions.FETCH_MOMENTS_REQUEST,
    fetchMomentsWithWorkflowStatus
  )
}

export default [fetchMomentsSaga]
